import { useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { transactionPropTypes } from 'common/propTypes';
import TransactionCollapsed from './TransactionCollapsed';
import TransactionExpanded from './TransactionExpanded';
import { onRunForceExit } from 'common/api/run';
import { reactToastify, TOASTIFY_TYPES } from 'common/utils/reactToastify';
import { OrderContext } from 'ui/run/RunShow/OrderStore';
import _ from 'lodash';

const propTypes = {
  transaction: transactionPropTypes.isRequired,
  cumulativeProfit: PropTypes.number,
  runId: PropTypes.number.isRequired,
  isNumerousRuns: PropTypes.bool,
  isLive: PropTypes.bool.isRequired,
  orderType: PropTypes.string.isRequired,
  granularity: PropTypes.string.isRequired,
  runStatus: PropTypes.string.isRequired
};

const defaultProps = { cumulativeProfit: null, isNumerousRuns: false };

const Transaction = ({
  transaction, cumulativeProfit, runId, isNumerousRuns, isLive, orderType, granularity, runStatus
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOpenedModal, setIsOpenedModal] = useState(false);
  const { isRunHaveParallelCases } = useContext(OrderContext);
  const {
    isComplete,
    caseIndex,
    instrumentGroupIndex,
    userId
  } = transaction;

  const { currentUserId } = window;
  const isOrderBelongsToUser = _.toNumber(currentUserId) === _.toNumber(userId);
  const isShowCaseSquareOffBtn = runStatus === 'started' && !isComplete && isOrderBelongsToUser && isRunHaveParallelCases;

  const onClick = useCallback((event) => {
    if (isOpenedModal || $(event.target).parent('.ignore-expand-collapse').length > 0) return;
    setIsExpanded(!isExpanded);
  }, [isOpenedModal, isExpanded, setIsExpanded]);

  const onCaseForceExit = useCallback((isReload=true) => {
    onRunForceExit(runId, caseIndex, instrumentGroupIndex).then(() => {
      reactToastify('Manual exit completed successfully', TOASTIFY_TYPES.SUCCESS);
      if (isReload) setTimeout(() => window.location.reload(), 1000);
    }).catch(() => {
      reactToastify('Something went wrong, please try again', TOASTIFY_TYPES.ERROR);
    });
  }, [caseIndex, instrumentGroupIndex, runId]);

  const TransactionComponent = isExpanded ? TransactionExpanded : TransactionCollapsed;
  return (
     
    <tbody onClick={onClick}>
      <TransactionComponent
        cumulativeProfit={cumulativeProfit}
        transaction={transaction}
        orderType={orderType}
        runId={runId}
        runStatus={runStatus}
        onHandleModalInParent={() => {
          setIsOpenedModal(!isOpenedModal);
        }}
        isLive={isLive}
        isNumerousRuns={isNumerousRuns}
        granularity={granularity}
        isShowCaseSquareOffBtn={isShowCaseSquareOffBtn}
        onCaseForceExit={onCaseForceExit}
      />
    </tbody>
  );
};

Transaction.propTypes = propTypes;
Transaction.defaultProps = defaultProps;
export default Transaction;
